import {
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
} from '../PolymorphicSerializer.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  KSerializerzf77vz1967fq as KSerializer,
} from '../KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function decodeSequentially($this, compositeDecoder) {
  var klassName = compositeDecoder.i1r($this.h1m(), 0);
  var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
  return compositeDecoder.l1r($this.h1m(), 1, serializer);
}
var AbstractPolymorphicSerializerClass;
function AbstractPolymorphicSerializer() {
  if (AbstractPolymorphicSerializerClass === VOID) {
    class $ {
      static r1m() {
        return createThis(this);
      }
      b1n(encoder, value) {
        var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.h1m();
        var composite = encoder.y1q(descriptor);
        composite.o1s(this.h1m(), 0, actualSerializer.h1m().k1n());
        var tmp = this.h1m();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$2 = isInterface(actualSerializer, SerializationStrategy()) ? actualSerializer : THROW_CCE();
        composite.q1s(tmp, 1, tmp$ret$2, value);
        composite.z1q(descriptor);
      }
      i1m(encoder, value) {
        return this.b1n(encoder, !(value == null) ? value : THROW_CCE());
      }
      j1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.h1m();
        var composite = decoder.y1q(descriptor);
        var tmp$ret$1;
        $l$block: {
          var klassName = null;
          var value = null;
          if (composite.o1r()) {
            tmp$ret$1 = decodeSequentially(this, composite);
            break $l$block;
          }
          mainLoop: while (true) {
            var index = composite.p1r(this.h1m());
            switch (index) {
              case -1:
                break mainLoop;
              case 0:
                klassName = composite.i1r(this.h1m(), index);
                break;
              case 1:
                var tmp0 = klassName;
                var tmp$ret$2;
                $l$block_0: {
                  // Inline function 'kotlin.requireNotNull' call
                  if (tmp0 == null) {
                    var message = 'Cannot read polymorphic value before its type token';
                    throw IllegalArgumentException().n2(toString(message));
                  } else {
                    tmp$ret$2 = tmp0;
                    break $l$block_0;
                  }
                }

                klassName = tmp$ret$2;
                var serializer = findPolymorphicSerializer(this, composite, klassName);
                value = composite.l1r(this.h1m(), index, serializer);
                break;
              default:
                var tmp0_elvis_lhs = klassName;
                throw SerializationException().c1o('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
            }
          }
          var tmp0_0 = value;
          var tmp$ret$4;
          $l$block_1: {
            // Inline function 'kotlin.requireNotNull' call
            if (tmp0_0 == null) {
              var message_0 = 'Polymorphic value has not been read for class ' + klassName;
              throw IllegalArgumentException().n2(toString(message_0));
            } else {
              tmp$ret$4 = tmp0_0;
              break $l$block_1;
            }
          }
          var tmp = tmp$ret$4;
          tmp$ret$1 = !(tmp == null) ? tmp : THROW_CCE();
        }
        var result = tmp$ret$1;
        composite.z1q(descriptor);
        return result;
      }
      k1m(decoder, klassName) {
        return decoder.n1r().x1s(this.l1m(), klassName);
      }
      m1m(encoder, value) {
        return encoder.n1r().y1s(this.l1m(), value);
      }
    }
    initMetadataForClass($, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer()]);
    AbstractPolymorphicSerializerClass = $;
  }
  return AbstractPolymorphicSerializerClass;
}
function throwSubtypeNotRegistered(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.j1() + "'";
  throw SerializationException().c1o(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.j1() + "' has to be sealed and '@Serializable'."));
}
function throwSubtypeNotRegistered_0(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.j1();
  throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
//region block: exports
export {
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  throwSubtypeNotRegistered as throwSubtypeNotRegistered2cr459177l268,
  throwSubtypeNotRegistered_0 as throwSubtypeNotRegistered343gt7v9eqwun,
};
//endregion

//# sourceMappingURL=AbstractPolymorphicSerializer.mjs.map
